import { AnimatePresence, motion } from 'motion/react';
import React__default, { useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import '../../rev/layouts/Alignment/alignment.scss';
import '../../rev/layouts/Box.js';
import { Group } from '../../rev/layouts/Group.js';
import '../../rev/layouts/Section.js';
import '../../rev/layouts/Spacing/spacing.scss';
import { Stack } from '../../rev/layouts/Stack.js';
import '../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../rev/atoms/Breadcrumbs.scss';
import { Button } from '../../rev/atoms/Button.js';
import { Callout } from '../../rev/atoms/Callout.js';
import '../../rev/atoms/Card.scss';
import '../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../rev/atoms/CheckboxGroup.scss';
import '../../rev/atoms/Tag.scss';
import '../../rev/atoms/Chip.scss';
import '../../rev/atoms/DateInput.js';
import '../../rev/atoms/Text.js';
import '../../rev/atoms/Divider.scss';
import '../../rev/atoms/Spinner.scss';
import '../../rev/atoms/Dropzone.scss';
import '../../rev/atoms/Empty.scss';
import '../../rev/molecules/RichDescription.js';
import '../../rev/molecules/TitleGroup.scss';
import '../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../rev/atoms/LabelledList.scss';
import '../../rev/atoms/LabelPrice.scss';
import '../../rev/atoms/Link.scss';
import '../../rev/atoms/ListViewGroup.scss';
import '../../rev/atoms/ListViewRow.scss';
import '../../rev/atoms/Note.scss';
import '../../rev/atoms/OldTextInput.js';
import '../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../rev/atoms/SegmentedControl.scss';
import '../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../rev/molecules/Tooltip/Tooltip.js';
import '../../rev/atoms/Slider.scss';
import '../../rev/atoms/SteppedProgressBar.scss';
import '../../rev/atoms/Switch.js';
import '../../rev/atoms/Tabs.scss';
import '../../rev/atoms/TextArea.js';
import { TextInput } from '../../rev/atoms/TextInput.js';
import '../../rev/atoms/TimeInput.js';
import '../../rev/atoms/ToggleButton.js';
import '../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../rev/molecules/Accordion.scss';
import '../../rev/molecules/ActionMenu.scss';
import '../../rev/molecules/BankInfo/BankInfo.scss';
import '../../rev/molecules/Carousel.scss';
import '../../rev/molecules/ContentSlider.js';
import '../../rev/molecules/Drawer.js';
import '../../rev/molecules/Dropdown.scss';
import '../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../rev/molecules/Lightbox.scss';
import 'jotai';
import '../../components/loadingAtoms.js';
import '../../rev/molecules/LoadingPage.scss';
import '../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../utils/addressCache.js';
import '../../rev/molecules/OldAddressInput.scss';
import '../../rev/atoms/Button.scss';
import '../../rev/molecules/OrderFooter.scss';
import '../../rev/molecules/Pagination.scss';
import '../../rev/molecules/Popover.js';
import '../../rev/molecules/Popup.scss';
import '../../rev/molecules/SearchInput.scss';
import '../../rev/molecules/Sheet.js';
import '../../rev/molecules/Table/Table.scss';
import '../../rev/molecules/Toast.js';
import '../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import '@react-aria/utils';
import '../../rev/molecules/TopBar.scss';
import '@mui/icons-material/Check';
import '../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../rev/organisms/AddressInput.js';
import '../../rev/sections/CalculatePaymentModal.scss';
import '../../rev/sections/ConfirmAddressModal.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import '../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../constants.js';
import '../../rev/sections/FormModal/FormModal.scss';
import '../../rev/sections/FormModal/types.js';
import 'moment';
import '../../types/leads/Lead.js';
import '../../rev/sections/LeadsSection/LeadCard.scss';
import { useAuth } from '../hooks/useAuth.js';
import { useAuthContext } from '../providers/AuthContext.js';
import { getLoginErrorMessage } from '../utils/authErrorMessages.js';
import { AuthHeader } from './common/AuthHeader.js';
import { EyeIcon, EyeOffIcon } from './common/AuthIcons.js';

const DEFAULT_DETAILS = [
    'Manage your inventory, orders, leads, site, and settings all in one place.',
];
/**
 * Simple email format validation
 */
function isValidEmail(email) {
    // Basic email regex - checks for something@something.something
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
/**
 * Validate email field - returns true if valid, error message if invalid
 */
function validateEmail(email) {
    const trimmed = email.trim();
    if (!trimmed || !isValidEmail(trimmed)) {
        return 'Enter a valid email';
    }
    return true;
}
/**
 * Validate password field - returns true if valid, error message if invalid
 */
function validatePassword(password) {
    if (!password) {
        return 'Enter a valid password';
    }
    return true;
}
/**
 * LoginForm component
 *
 * Handles email/password login with MFA challenge support.
 * Uses callback props for navigation decisions (caller handles routing).
 */
function LoginForm({ title = 'Log in', details, emailLabel = 'Email', hidePasswordInitially = false, continueButtonText = 'Continue', signInButtonText = 'Log in', disclaimer, onLoginSuccess, onForgotPassword, error: externalError, hideForgotPassword = false, isProcessing = false, checkUserEndpoint = '/buyer_onfetch_v2/checkAuthAccountExists', onNewUserDetected, }) {
    const { signIn, isSigningIn } = useAuth();
    const { apiClient } = useAuthContext();
    // Step-based flow: step 1 = email only, step 2 = email + password (when hidePasswordInitially)
    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    const [isCheckingEmail, setIsCheckingEmail] = useState(false);
    const isStep1 = hidePasswordInitially && step === 1;
    const emailCheckTimeoutRef = useRef(null);
    // Server error state (for auth errors like invalid credentials)
    const [internalError, setInternalError] = useState(null);
    // Use external error if provided, otherwise use internal error
    const error = externalError ?? internalError;
    const { control, handleSubmit, getValues, watch, formState: { errors, isSubmitting, isValid }, } = useForm({
        mode: 'onChange',
        defaultValues: {
            email: '',
            password: '',
        },
    });
    // Watch email value and debounce it
    const emailValue = watch('email');
    useEffect(() => {
        // Only run this check if we're using two-step flow AND in step 2 with valid email
        if (hidePasswordInitially && step === 2 && emailValue && isValidEmail(emailValue)) {
            // Clear any existing timeout
            if (emailCheckTimeoutRef.current) {
                clearTimeout(emailCheckTimeoutRef.current);
            }
            // Set a new timeout for 500ms
            emailCheckTimeoutRef.current = setTimeout(() => {
                handleEmailContinue(emailValue);
            }, 500);
        }
        return () => {
            if (emailCheckTimeoutRef.current) {
                clearTimeout(emailCheckTimeoutRef.current);
            }
        };
    }, [emailValue, hidePasswordInitially, step]);
    const handleEmailContinue = async (email) => {
        setIsCheckingEmail(true);
        setInternalError(null);
        try {
            const response = await apiClient.post(checkUserEndpoint, {
                email: email.trim().toLowerCase(),
            });
            // Support both wrapped { data } (ApiResponse) and raw body (e.g. buyer portal axios)
            const payload = response && typeof response === 'object' && 'data' in response
                ? response.data
                : response;
            const { authAccountExists: authAccountByEmailExists, hasPasswordProvider, buyerDocExists, isEkhoAdmin, } = (payload ?? {});
            // Accounts with the ekhoAdmin custom claim bypass the buyer-doc
            // requirement so Ekho staff can log in for god mode.
            if (isEkhoAdmin && authAccountByEmailExists && hasPasswordProvider) {
                setStep(2);
                return;
            }
            // Block dealer/admin accounts from buyer portal login
            if (authAccountByEmailExists && hasPasswordProvider && !buyerDocExists) {
                setInternalError('This is a dealer/oem account. Please use the admin portal.');
                setIsCheckingEmail(false);
                setStep(1);
                return;
            }
            // Existing buyer who hasn't set a password
            if ((!authAccountByEmailExists || !hasPasswordProvider) && buyerDocExists) {
                onNewUserDetected?.(email.trim().toLowerCase());
                setStep(1);
                return;
            }
            // Existing buyer who has set a password
            if (authAccountByEmailExists && hasPasswordProvider && buyerDocExists) {
                setStep(2);
                return;
            }
            // No buyer exists for this email (and is not a dealer/oem account)
            // (For now, throwing a generic error to at least try to prevent account enumeration)
            setInternalError('Unable to check account status. Please try again.');
            setIsCheckingEmail(false);
            setStep(1);
            return;
        }
        catch (err) {
            console.error('Error checking user:', err);
            setInternalError('Unable to check account status. Please try again.');
        }
        finally {
            setIsCheckingEmail(false);
        }
    };
    const onSubmit = handleSubmit(async (data) => {
        // Clear previous server errors (only internal, external errors are controlled by parent)
        setInternalError(null);
        // Step 1 (email-only): check user and either advance to step 2 or route to new-user flow
        if (isStep1) {
            await handleEmailContinue(data.email);
            return;
        }
        try {
            // Attempt sign in
            const result = await signIn({
                email: data.email.trim().toLowerCase(),
                password: data.password,
            });
            // Check if MFA challenge is required
            if (!result.success && result.mfaRequired) {
                // MFA atoms have been set by useAuth.signIn
                // Caller will render MfaChallengeForm instead of this form
                // Don't call onLoginSuccess - caller will handle MFA flow
                return;
            }
            // Sign-in succeeded without MFA - call success callback
            // Caller can check needsMfaEnrollment atom if needed
            onLoginSuccess?.();
        }
        catch (err) {
            console.error(err);
            const authError = err;
            setInternalError(getLoginErrorMessage(authError.code));
        }
    });
    const emailOnlyValid = !errors.email?.message && !!getValues('email')?.trim();
    const isSubmitDisabled = isStep1
        ? isCheckingEmail || !emailOnlyValid
        : isSigningIn || isSubmitting || !isValid;
    return (React__default.createElement("form", { onSubmit: onSubmit },
        React__default.createElement(Stack, { itemsSpacing: '24' },
            React__default.createElement(AuthHeader, { title: title, details: details ?? DEFAULT_DETAILS }),
            React__default.createElement(Stack, { itemsSpacing: '16' },
                React__default.createElement(Controller, { name: 'email', control: control, rules: {
                        validate: validateEmail,
                    }, render: ({ field: { onChange, onBlur, value } }) => (React__default.createElement(TextInput, { label: emailLabel, type: 'email', value: value, onChange: onChange, onBlur: onBlur, placeholder: '', name: 'email', ariaLabel: emailLabel, hasError: errors.email?.message })) }),
                React__default.createElement(AnimatePresence, { initial: false }, !isStep1 && (React__default.createElement(motion.div, { key: 'password-field', initial: { height: 0, opacity: 0 }, animate: { height: 'auto', opacity: 1 }, exit: { height: 0, opacity: 0 }, transition: {
                        height: { duration: 0.25, ease: [0.33, 1, 0.68, 1] },
                        opacity: { duration: 0.2 },
                    }, style: { overflow: 'hidden' } },
                    React__default.createElement(Controller, { name: 'password', control: control, rules: {
                            validate: validatePassword,
                        }, render: ({ field: { onChange, onBlur, value } }) => (React__default.createElement(TextInput, { label: 'Password', type: showPassword ? 'text' : 'password', value: value, onChange: onChange, onBlur: onBlur, placeholder: '', name: 'password', ariaLabel: 'Password', hasError: errors.password?.message, rightContent: React__default.createElement("button", { type: 'button', className: 'auth-password-toggle', onClick: () => setShowPassword(!showPassword), "aria-label": showPassword
                                    ? 'Hide password'
                                    : 'Show password' }, showPassword ? React__default.createElement(EyeIcon, null) : React__default.createElement(EyeOffIcon, null)) })) })))),
                !hideForgotPassword && !isStep1 && (React__default.createElement(Group, { itemsAlignX: 'start' },
                    React__default.createElement(Button, { variant: 'underlined', onPress: () => {
                            const email = getValues('email');
                            onForgotPassword?.(email?.trim().toLowerCase());
                        } }, "Forgot password?"))),
                error && React__default.createElement(Callout, { variant: 'error', message: error })),
            React__default.createElement(Button, { type: 'submit', size: 'large', variant: 'filled', className: 'auth-primary-button', isDisabled: isSubmitDisabled || (isStep1 ? false : isProcessing), isLoading: isStep1 ? isCheckingEmail : isSigningIn || isSubmitting || isProcessing, onPress: () => onSubmit() }, isStep1
                ? continueButtonText
                : isProcessing
                    ? 'Signing in...'
                    : signInButtonText),
            disclaimer != null && React__default.createElement(Stack, { itemsSpacing: '0' }, disclaimer))));
}

export { LoginForm };
//# sourceMappingURL=LoginForm.js.map
